/**
 * Analytics event helpers — thin wrappers around logAnalyticsEvent
 * so event names and params stay consistent across the app.
 */
import { logAnalyticsEvent } from "../firebase";

// ── Sign-up & auth ──────────────────────────────────────────────
export function trackSignUp(method: "email" | "google") {
  logAnalyticsEvent("sign_up", { method });
}

// ── Paywall / Subscribe ─────────────────────────────────────────
export function trackPaywallView(source?: string) {
  logAnalyticsEvent("paywall_view", { ...(source ? { source } : {}) });
}

export function trackPurchase(planId: string, value: number, currency = "GBP") {
  logAnalyticsEvent("purchase", { plan_id: planId, value, currency });
}

export function trackSubscriptionActive(planId: string) {
  logAnalyticsEvent("subscription_active", { plan_id: planId });
}

// ── Fitness ─────────────────────────────────────────────────────
export function trackWorkoutStart(templateName: string) {
  logAnalyticsEvent("workout_start", { template_name: templateName });
}

// ── Women's Health ──────────────────────────────────────────────
export function trackPeriodLogged(action: "start" | "end") {
  logAnalyticsEvent("period_logged", { action });
}

// ── General engagement ──────────────────────────────────────────
export function trackFeatureUsed(feature: string) {
  logAnalyticsEvent("feature_used", { feature });
}
